import { memo as m } from "react";
import { getHorizontalArea as n } from "../../metrics/object-helpers/index2.js";
import { jsxs as t, jsx as r } from "react/jsx-runtime";
const i = m(({
  obj: e
}) => /* @__PURE__ */ t("text", {
  name: `${e.name}-room-text`,
  fontSize: 0.25,
  alignmentBaseline: "middle",
  textAnchor: "middle",
  style: {
    textAlign: "center"
  },
  children: [/* @__PURE__ */ r("tspan", {
    y: "-.5em",
    x: "0",
    children: e.name
  }), /* @__PURE__ */ t("tspan", {
    y: ".5em",
    x: "0",
    children: [n(e).toFixed(1), "m2"]
  })]
}));
i.displayName = "SvgRgObjectText";
export {
  i as SvgRgObjectText
};
//# sourceMappingURL=index5.js.map
